var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton, Stack, TableBody, TableCell, TableRow, Typography, styled } from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RumEntityLabel } from '../../../../observability/rumEntity';
import { Autocomplete, NativeNumberInput, NumberInput, UnControlledFormField } from '../../../common';
import { StableAutocomplete } from '../../../common/autocomplete/stable';
import { useCurrencySymbol, useRollupAvailableCurrencies } from '../../../hooks';
import { WizardTable } from '../../common/WizardTable';
import { FteSwitch } from '../../common/fteSwitch';
import { OrgConfigWizardContext } from '../../context';
import { saveLocationFinancials, useLocationFinancialsAPI, useOrgFinancialsAPI, } from '../../financials/selectors';
import { BasedOnCalculation, LocationRoleType, ROLE_TYPE_T_KEYS, RoleAppliesTo, saveLocationRoles, useRolesAPI, } from '../../staffing/selectors';
var StyledAgentCell = styled(TableCell)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.background.default,
    });
});
var toBaseline = function (f) { return ({
    currencyCode: f.currencyCode,
    overtimePercent: f.overtimePercent,
    premiumMultiplier: f.premiumMultiplier,
    roles: f.roles.map(function (r) { return (__assign({}, r)); }),
}); };
var baselinesEqual = function (a, b) {
    if (a.currencyCode !== b.currencyCode ||
        a.overtimePercent !== b.overtimePercent ||
        a.premiumMultiplier !== b.premiumMultiplier) {
        return false;
    }
    if (a.roles.length !== b.roles.length)
        return false;
    return a.roles.every(function (r, i) {
        var o = b.roles[i];
        return (r.roleName === o.roleName &&
            r.ratio === o.ratio &&
            r.roleAppliesTo === o.roleAppliesTo &&
            r.basedOnCalculation === o.basedOnCalculation &&
            r.wageType === o.wageType &&
            r.amount === o.amount &&
            r.loadFactor === o.loadFactor &&
            r.isDeleted === o.isDeleted);
    });
};
var toNum = function (v) {
    var n = Number.parseFloat(v);
    return Number.isFinite(n) ? n : null;
};
var wageTypeFromApi = function (raw) {
    if (raw === 'hourly')
        return 'hourly';
    return 'annual_salary';
};
var buildCombinedForm = function (financialsData, rolesData) {
    var _a, _b, _c, _d, _e, _f;
    var wageMap = new Map(((_a = financialsData.roles) !== null && _a !== void 0 ? _a : []).map(function (r) { return [r.roleName, r]; }));
    var agentWage = wageMap.get('Agent');
    var agentRow = {
        roleName: 'Agent',
        roleItemId: null,
        roleType: null,
        isAgent: true,
        isCustom: false,
        ratio: '',
        roleAppliesTo: '',
        basedOnCalculation: BasedOnCalculation.Headcount,
        wageType: wageTypeFromApi(agentWage === null || agentWage === void 0 ? void 0 : agentWage.wageType),
        amount: (_b = agentWage === null || agentWage === void 0 ? void 0 : agentWage.amount) !== null && _b !== void 0 ? _b : '',
        loadFactor: (_c = agentWage === null || agentWage === void 0 ? void 0 : agentWage.loadFactor) !== null && _c !== void 0 ? _c : '',
        isDeleted: false,
    };
    var supportRows = rolesData.map(function (roleItem) {
        var _a, _b;
        var wage = wageMap.get(roleItem.roleName);
        return {
            roleName: roleItem.roleName,
            roleItemId: roleItem.id,
            roleType: roleItem.roleType,
            isAgent: false,
            isCustom: Boolean(roleItem.isCustom),
            ratio: roleItem.ratio == null ? '' : String(roleItem.ratio),
            roleAppliesTo: roleItem.roleAppliesTo,
            basedOnCalculation: roleItem.basedOnCalculation,
            wageType: wageTypeFromApi(wage === null || wage === void 0 ? void 0 : wage.wageType),
            amount: (_a = wage === null || wage === void 0 ? void 0 : wage.amount) !== null && _a !== void 0 ? _a : '',
            loadFactor: (_b = wage === null || wage === void 0 ? void 0 : wage.loadFactor) !== null && _b !== void 0 ? _b : '',
            isDeleted: false,
        };
    });
    return {
        currencyCode: (_d = financialsData.currencyCode) !== null && _d !== void 0 ? _d : 'USD',
        overtimePercent: (_e = financialsData.overtimePercent) !== null && _e !== void 0 ? _e : '',
        premiumMultiplier: (_f = financialsData.premiumMultiplier) !== null && _f !== void 0 ? _f : '',
        roles: __spreadArray([agentRow], supportRows, true),
        isDirty: false,
    };
};
var ROLE_APPLIES_TO_VALUES = [RoleAppliesTo.Queue, RoleAppliesTo.Site];
export var ReviewFinancialsSection = function (_a) {
    var _b, _c, _d;
    var locationId = _a.locationId, registry = _a.registry, _e = _a.isFinancialsDisabled, isFinancialsDisabled = _e === void 0 ? false : _e;
    var tReview = useTranslation('orgConfig', { keyPrefix: 'orgConfigWizard.reviewStep' }).t;
    var tFinancials = useTranslation('orgConfig', { keyPrefix: 'financials' }).t;
    var tStaffing = useTranslation('orgConfig', { keyPrefix: 'staffing' }).t;
    var _f = useContext(OrgConfigWizardContext), _g = _f.isReadOnly, isReadOnly = _g === void 0 ? false : _g, configVersionId = _f.configVersionId;
    var _h = useOrgFinancialsAPI(configVersionId), orgFinancialsData = _h[0], fetchOrgFinancials = _h[1];
    var rollupCurrency = ((_c = (_b = orgFinancialsData.data) === null || _b === void 0 ? void 0 : _b.rollupCurrency) !== null && _c !== void 0 ? _c : 'USD').toUpperCase();
    var _j = useRollupAvailableCurrencies(rollupCurrency, { configVersionId: configVersionId }), optionsForValue = _j.optionsForValue, isSupported = _j.isSupported, availableRequesting = _j.requesting;
    var _k = useLocationFinancialsAPI(locationId), financialsData = _k[0], fetchFinancials = _k[1];
    var _l = useRolesAPI(locationId), rolesData = _l[0], fetchRoles = _l[1];
    var _m = useState({}), formMap = _m[0], setFormMap = _m[1];
    var formMapRef = useRef(formMap);
    useEffect(function () {
        formMapRef.current = formMap;
    }, [formMap]);
    var baselineRef = useRef({});
    var form = (_d = formMap[locationId]) !== null && _d !== void 0 ? _d : null;
    var currencyOptions = optionsForValue(form === null || form === void 0 ? void 0 : form.currencyCode);
    var currencyUnsupported = Boolean((form === null || form === void 0 ? void 0 : form.currencyCode) && !isSupported(form.currencyCode));
    useEffect(function () {
        if (configVersionId) {
            fetchOrgFinancials();
        }
    }, [configVersionId, fetchOrgFinancials]);
    useEffect(function () {
        if (locationId) {
            fetchFinancials();
            fetchRoles();
        }
    }, [locationId, fetchFinancials, fetchRoles]);
    useEffect(function () {
        var fData = financialsData.data;
        var rData = rolesData.data;
        if (!fData || !rData)
            return;
        setFormMap(function (prev) {
            var _a;
            var _b;
            if ((_b = prev[locationId]) === null || _b === void 0 ? void 0 : _b.isDirty)
                return prev;
            var mapped = buildCombinedForm(fData, rData);
            baselineRef.current[locationId] = toBaseline(mapped);
            return __assign(__assign({}, prev), (_a = {}, _a[locationId] = mapped, _a));
        });
    }, [financialsData.data, rolesData.data, locationId]);
    var handleTopFieldChange = useCallback(function (field, value) {
        setFormMap(function (prev) {
            var _a, _b;
            var current = prev[locationId];
            if (!current)
                return prev;
            return __assign(__assign({}, prev), (_a = {}, _a[locationId] = __assign(__assign({}, current), (_b = {}, _b[field] = value, _b.isDirty = true, _b)), _a));
        });
    }, [locationId]);
    var handleRoleChange = useCallback(function (index, patch) {
        setFormMap(function (prev) {
            var _a;
            var current = prev[locationId];
            if (!current)
                return prev;
            var roles = current.roles.map(function (r, i) { return (i === index ? __assign(__assign({}, r), patch) : r); });
            return __assign(__assign({}, prev), (_a = {}, _a[locationId] = __assign(__assign({}, current), { roles: roles, isDirty: true }), _a));
        });
    }, [locationId]);
    var doSave = useCallback(function (locId) { return __awaiter(void 0, void 0, void 0, function () {
        var f, baseline, wages, nonAgentRoles, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    f = formMapRef.current[locId];
                    if (!(f === null || f === void 0 ? void 0 : f.isDirty))
                        return [2 /*return*/, true];
                    if (!isFinancialsDisabled && f.currencyCode && !isSupported(f.currencyCode)) {
                        return [2 /*return*/, false];
                    }
                    baseline = baselineRef.current[locId];
                    if (baseline && baselinesEqual(toBaseline(f), baseline)) {
                        setFormMap(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), { isDirty: false }), _a)));
                        });
                        return [2 /*return*/, true];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!!isFinancialsDisabled) return [3 /*break*/, 3];
                    wages = f.roles
                        .filter(function (r) { return !r.isDeleted && Boolean(r.wageType) && toNum(r.amount) !== null; })
                        .map(function (r) { return ({
                        roleName: r.roleName,
                        wageType: r.wageType,
                        amount: toNum(r.amount),
                        loadFactor: toNum(r.loadFactor),
                    }); });
                    return [4 /*yield*/, saveLocationFinancials(locId, {
                            currencyCode: f.currencyCode || null,
                            overtimePercent: toNum(f.overtimePercent),
                            premiumMultiplier: toNum(f.premiumMultiplier),
                            wages: wages,
                        })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    nonAgentRoles = f.roles.filter(function (r) { return !r.isAgent; });
                    if (!(nonAgentRoles.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, saveLocationRoles(locId, nonAgentRoles.map(function (r) {
                            var _a;
                            return ({
                                id: r.roleItemId,
                                roleName: r.roleName,
                                roleType: (_a = r.roleType) !== null && _a !== void 0 ? _a : LocationRoleType.Custom,
                                roleAppliesTo: r.roleAppliesTo || RoleAppliesTo.Queue,
                                basedOnCalculation: r.basedOnCalculation,
                                isCustom: Boolean(r.isCustom),
                                isDeleted: r.isDeleted,
                                ratio: toNum(r.ratio),
                            });
                        }))];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    baselineRef.current[locId] = toBaseline(f);
                    setFormMap(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), { isDirty: false }), _a)));
                    });
                    return [2 /*return*/, true];
                case 6:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [isSupported, isFinancialsDisabled]);
    var scheduleDebouncedSave = useMemo(function () {
        return debounce(function (locId) {
            void doSave(locId);
        }, 500);
    }, [doSave]);
    useEffect(function () {
        if (!(form === null || form === void 0 ? void 0 : form.isDirty))
            return;
        scheduleDebouncedSave(locationId);
    }, [
        form === null || form === void 0 ? void 0 : form.isDirty,
        form === null || form === void 0 ? void 0 : form.currencyCode,
        form === null || form === void 0 ? void 0 : form.overtimePercent,
        form === null || form === void 0 ? void 0 : form.premiumMultiplier,
        form === null || form === void 0 ? void 0 : form.roles,
        locationId,
        scheduleDebouncedSave,
    ]);
    useEffect(function () {
        registry.register('financials', {
            flush: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    scheduleDebouncedSave.cancel();
                    return [2 /*return*/, doSave(locationId)];
                });
            }); },
            cancelPending: function () { return scheduleDebouncedSave.cancel(); },
            get isDirty() {
                var _a, _b;
                return (_b = (_a = formMapRef.current[locationId]) === null || _a === void 0 ? void 0 : _a.isDirty) !== null && _b !== void 0 ? _b : false;
            },
        });
        return function () { return registry.unregister('financials'); };
    }, [registry, locationId, scheduleDebouncedSave, doSave]);
    var getRoleDisplayName = useCallback(function (row) {
        if (row.isAgent) {
            return String(tFinancials('table.agent', { defaultValue: 'Agent' }));
        }
        if (row.roleType === LocationRoleType.Custom) {
            return row.roleName;
        }
        var tKey = row.roleType ? ROLE_TYPE_T_KEYS[row.roleType] : null;
        if (tKey) {
            return String(tStaffing(tKey, { defaultValue: row.roleName }));
        }
        return row.roleName;
    }, [tFinancials, tStaffing]);
    var appliesToOptions = useMemo(function () {
        return ROLE_APPLIES_TO_VALUES.map(function (val) { return ({
            id: val,
            name: val === RoleAppliesTo.Queue
                ? String(tStaffing('roles.appliesTo.queue', { defaultValue: 'Queue' }))
                : String(tStaffing('roles.appliesTo.site', { defaultValue: 'Site' })),
        }); });
    }, [tStaffing]);
    var _o = useCurrencySymbol(form === null || form === void 0 ? void 0 : form.currencyCode), currencySymbol = _o.currencySymbol, prefix = _o.prefix, suffix = _o.suffix;
    if (!form)
        return _jsx(Skeleton, { variant: "rectangular", height: 200, sx: { borderRadius: 1 } });
    // The Agent row only carries wage fields, so it goes when they are hidden.
    var visibleRoles = form.roles.filter(function (r) { return !r.isDeleted && !(isFinancialsDisabled && r.isAgent); });
    // Only reachable with the financial fields hidden: otherwise the Agent row is always listed.
    if (visibleRoles.length === 0) {
        return (_jsx(Typography, __assign({ variant: "body2", color: "text.secondary" }, { children: tStaffing('noRoles', { defaultValue: 'No support roles configured.' }) })));
    }
    return (_jsxs(Stack, __assign({ spacing: 4 }, { children: [!isFinancialsDisabled && (_jsxs(Stack, __assign({ direction: "row", spacing: 3, alignItems: "flex-end", flexWrap: "wrap", useFlexGap: true }, { children: [_jsx(UnControlledFormField, __assign({ label: String(tFinancials('location.currency', { defaultValue: 'Currency' })), sx: { flex: 1, minWidth: 0 } }, { children: _jsx(Autocomplete, { size: "small", value: form.currencyCode, options: currencyOptions, disabled: isReadOnly || availableRequesting, error: currencyUnsupported, helperText: currencyUnsupported
                                ? String(tFinancials('errors.unsupportedCurrencySelected', {
                                    defaultValue: '{{currency}} cannot be converted to {{rollup}}. Please select another currency.',
                                    currency: form.currencyCode,
                                    rollup: rollupCurrency,
                                }))
                                : undefined, sx: { width: '8rem' }, onChange: function (v) { return handleTopFieldChange('currencyCode', v); } }) })), _jsx(UnControlledFormField, __assign({ label: String(tFinancials('location.overtimePercent', { defaultValue: 'Overtime costs' })), unitLabel: "%", sx: { flex: 1, minWidth: 0 } }, { children: _jsx(NumberInput, { size: "small", min: 0, max: 100, decimal: 2, value: form.overtimePercent, onChange: function (v) { return handleTopFieldChange('overtimePercent', v == null ? '' : String(v)); }, disabled: isReadOnly }) })), _jsx(UnControlledFormField, __assign({ label: String(tFinancials('location.premiumMultiplier', { defaultValue: 'Overtime premium multiplier' })), sx: { flex: 1, minWidth: 0 } }, { children: _jsx(NumberInput, { size: "small", min: 0, max: 5, decimal: 2, value: form.premiumMultiplier, onChange: function (v) { return handleTopFieldChange('premiumMultiplier', v == null ? '' : String(v)); }, disabled: isReadOnly }) }))] }))), _jsx(WizardTable, __assign({ headers: _jsxs(_Fragment, { children: [_jsx(TableCell, { children: tFinancials('table.role', { defaultValue: 'Role' }) }), _jsx(TableCell, { children: tStaffing('roleAppliesTo', { defaultValue: 'Role applies to' }) }), _jsx(TableCell, __assign({ align: "center" }, { children: tReview('ratioToAgents', { defaultValue: 'Ratio to agents' }) })), _jsx(TableCell, __assign({ align: "center" }, { children: tStaffing('calculatedBasedOn', { defaultValue: 'Calculated based on' }) })), !isFinancialsDisabled && (_jsxs(_Fragment, { children: [_jsx(TableCell, { children: tFinancials('table.wageType', { defaultValue: 'Wage type' }) }), _jsx(TableCell, __assign({ align: "center" }, { children: tFinancials('table.amount', { defaultValue: 'Amount' }) })), _jsx(TableCell, __assign({ align: "center" }, { children: tFinancials('table.loadFactor', { defaultValue: 'Load Factor (%)' }) }))] }))] }) }, { children: _jsx(TableBody, { children: visibleRoles.map(function (row) {
                        var actualIdx = form.roles.indexOf(row);
                        var isFte = row.basedOnCalculation === BasedOnCalculation.Fte;
                        return (_jsxs(TableRow, { children: [_jsx(TableCell, __assign({ sx: { minWidth: 160, bgcolor: 'background.default' } }, { children: _jsx(Typography, { children: _jsx(RumEntityLabel, __assign({ kind: "role", id: row.roleType === LocationRoleType.Custom ? row.roleItemId : undefined }, { children: getRoleDisplayName(row) })) }) })), row.isAgent ? (_jsx(StyledAgentCell, { sx: { minWidth: 140 } })) : (_jsx(TableCell, __assign({ sx: { minWidth: 140 } }, { children: _jsx(Autocomplete, { size: "small", value: row.roleAppliesTo, placeholder: tStaffing('roles.pleaseSelect', { defaultValue: 'Please select' }), options: appliesToOptions, disabled: isReadOnly, onChange: function (v) { return handleRoleChange(actualIdx, { roleAppliesTo: v }); } }) }))), row.isAgent ? (_jsx(StyledAgentCell, { sx: { minWidth: 100 } })) : (_jsx(TableCell, __assign({ sx: { minWidth: 100 } }, { children: _jsx(NumberInput, { fullWidth: true, size: "small", min: 1, max: 99999, decimal: 0, value: row.ratio, onChange: function (v) { return handleRoleChange(actualIdx, { ratio: v == null ? '' : String(v) }); }, disabled: isReadOnly, inputProps: { style: { textAlign: 'center' } } }) }))), row.isAgent ? (_jsx(StyledAgentCell, { sx: { minWidth: 180 } })) : (_jsx(TableCell, __assign({ sx: {
                                        p: '0 !important',
                                        minWidth: 180,
                                    } }, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "center", spacing: 1 }, { children: [_jsx(Typography, __assign({ color: isFte ? 'text.primary' : 'text.secondary' }, { children: tStaffing('roles.fte', { defaultValue: 'FTE' }) })), _jsx(FteSwitch, { checked: !isFte, disabled: isReadOnly, onChange: function () {
                                                    return handleRoleChange(actualIdx, {
                                                        basedOnCalculation: isFte ? BasedOnCalculation.Headcount : BasedOnCalculation.Fte,
                                                    });
                                                } }), _jsx(Typography, __assign({ color: isFte ? 'text.secondary' : 'text.primary' }, { children: tStaffing('roles.headcount', { defaultValue: 'Headcount' }) }))] })) }))), !isFinancialsDisabled && (_jsxs(_Fragment, { children: [_jsx(TableCell, __assign({ sx: { minWidth: 160 } }, { children: _jsx(StableAutocomplete, { size: "small", value: row.wageType || 'annual_salary', options: [
                                                    { id: 'hourly', name: tFinancials('table.hourly', { defaultValue: 'Hourly Salary' }) },
                                                    { id: 'annual_salary', name: tFinancials('table.annual', { defaultValue: 'Annual Salary' }) },
                                                ], disabled: isReadOnly, onChange: function (v) {
                                                    var next = v;
                                                    handleRoleChange(actualIdx, { wageType: next, amount: '' });
                                                } }) })), _jsx(TableCell, __assign({ sx: { minWidth: 140 } }, { children: _jsx(NativeNumberInput, { min: 1, max: 10000000, decimal: 2, value: row.amount, disabled: isReadOnly, onChange: function (v) { return handleRoleChange(actualIdx, { amount: v == null ? '' : String(v) }); }, placeholder: currencySymbol, prefix: prefix, suffix: suffix }) })), _jsx(TableCell, __assign({ sx: { minWidth: 120 } }, { children: _jsx(NumberInput, { fullWidth: true, size: "small", min: 0, max: 100, decimal: 2, value: row.loadFactor, disabled: isReadOnly, onChange: function (v) { return handleRoleChange(actualIdx, { loadFactor: v == null ? '' : String(v) }); }, inputProps: { style: { textAlign: 'center' } }, suffix: '%' }) }))] }))] }, row.roleName));
                    }) }) }))] })));
};
